// @flow

import * as React from 'react';
import { connect } from 'react-redux';
import { localize, unescaped } from '@ta/common.i18n';

import type { InternalContentProps } from './base';
import { DefaultProps, defaultConnect } from './base';
import ReportIAPPanel from '../ReportIAPPanel';
import { ContentType } from '../submit/SubmitIapVote';

/**
 * Panel for reporting a link.
 */
const ReportMemberPanel = (props: InternalContentProps) => {
  const locale = props.locale.replace('_', '-').toLocaleLowerCase();
  const guidelines = unescaped(
    localize('iap_profile_report_from_post_lev2', {
      sUrl: `https://www.tripadvisorsupport.com/hc/${locale}/articles/360008133913-TripAdvisor-s-Content-Policy`,
    }),
  );
  // All concerns related to a user's contributions need to be reported directly from the individual post that violates <a href="{sUrl}">our guidelines.</a>
  const generalSupport = unescaped(localize('iap_profile_general_support_lev2'));
  //    "Our <a href="/GeneralSupport">General Support Form</a> can help you address issues with your account."
  const inbox = unescaped(localize('iap_profile_report_from_inbox_lev2'));
  // Report messages directly from the message in your <a href="/Inbox">inbox</a>.

  return (
    <ReportIAPPanel
      csrfToken={props.csrfToken}
      userId={props.userId}
      contentId={props.contentId}
      contentType={ContentType.PROFILE}
      onError={props.onError}
      onComplete={props.onComplete}
    >
      {panel => (
        <React.Fragment>
          {panel.createRadioWithText(
            'PROFILE_PROBLEM_WITH_PHOTO',
            localize('iap_profile_problem_with_pic_lev2'),
            // To report other photos posted by this user, please report directly from the photo(s).
          )}
          {panel.createRadio('PROFILE_PROBLEM_WITH_LINK')}
          {panel.createRadio('PROFILE_IAP_USERNAME')}
          {panel.createRadioWithContentNoSubmit(
            'PROFILE_IAP_CONTRIBUTION',
            <span>{guidelines}</span>,
          )}
          {panel.createRadioWithContentNoSubmit(
            'PROFILE_PROBLEM_MY_ACCOUNT',
            <span>{generalSupport}</span>,
          )}
          {panel.createRadioWithContentNoSubmit('PROFILE_UNWANTED_MESSAGE', <span>{inbox}</span>)}
        </React.Fragment>
      )}
    </ReportIAPPanel>
  );
};
ReportMemberPanel.defaultProps = DefaultProps;

// $FlowFixMe92
export default connect(state => defaultConnect(state))(ReportMemberPanel);
